import React from 'react';

const HexagonSvg = ({ color = 'D4D7DD' }: { color: string }): JSX.Element => (
  <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 0L22.3253 6.25V18.75L11.5 25L0.674683 18.75V6.25L11.5 0Z" fill={color} />
  </svg>
);

export default HexagonSvg;
